import { createContext } from "react";
import { iEnquiry } from "../interfaces/iEnquiry";
export const ExportEnquiriesContext = createContext((enquiries: Array<iEnquiry>) => {});
